import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { CheckCircle2, Circle, Truck } from "lucide-react";

export default function CardTracker({ cardId }) {
  const [d, setD] = useState(null);
  useEffect(() => {
    const load = () => api.get(`/cards/${cardId}/dispatch`).then((r) => setD(r.data)).catch(() => {});
    load(); const t = setInterval(load, 20000); return () => clearInterval(t);
  }, [cardId]);
  if (!d || !d.dispatched) return null;
  return (
    <div className="panel p-5 mt-3" data-testid={`tracker-${cardId}`}>
      <div className="flex items-center gap-2 mb-3">
        <Truck size={16} className="text-[#d4af37]"/>
        <span className="font-mono text-xs text-white/70">{d.tracking_number}</span>
        <span className="chip cyan ml-auto">{d.current_stage_label}</span>
      </div>
      <div className="h-1.5 bg-white/5 rounded-full overflow-hidden mb-4">
        <div className="h-full bg-gradient-to-r from-[#d4af37] to-[#39ff14] transition-all" style={{ width: `${d.progress_pct}%` }} data-testid={`tracker-progress-${cardId}`}/>
      </div>
      <div className="grid grid-cols-6 gap-1">
        {d.timeline.map((t) => (
          <div key={t.code} className="text-center" data-testid={`stage-${cardId}-${t.code}`}>
            {t.reached
              ? <CheckCircle2 size={14} className="text-[#39ff14] mx-auto"/>
              : <Circle size={14} className="text-white/30 mx-auto"/>}
            <div className={`text-[9px] mt-1 font-mono ${t.reached ? "text-white/70" : "text-white/30"}`}>{t.label.split(" ")[0]}</div>
          </div>
        ))}
      </div>
      <div className="text-[10px] text-white/40 mt-3 font-mono">{d.technology} · ETA {new Date(d.eta).toLocaleDateString()}</div>
    </div>
  );
}
